
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/market-conduct/annual-review",
      function () {
        return require("private-next-pages/compliance/market-conduct/annual-review.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/market-conduct/annual-review"])
      });
    }
  